/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// 
// Force Order Notes open by default
(function() {
  const observer = new MutationObserver(function() {
    const noteDetails = document.querySelector('cart-note details');
    if (noteDetails && !noteDetails.hasAttribute('open')) {
      noteDetails.setAttribute('open', '');
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
